import { Component, type ReactNode } from "react";
import { RefreshCw } from "lucide-react";
import { Button } from "@/components/ui/button";

/** Shown if a page's code can't be loaded even after the one automatic reload: say so plainly, never a blank screen. */
export class ChunkErrorBoundary extends Component<{ children: ReactNode }, { failed: boolean }> {
  override state = { failed: false };
  static getDerivedStateFromError() {
    return { failed: true };
  }
  override render() {
    if (!this.state.failed) return this.props.children;
    return (
      <div role="alert" className="mx-auto flex max-w-md flex-col items-center gap-4 px-6 pt-24 text-center font-ui">
        <p className="font-display text-3xl italic">This page didn’t load.</p>
        <p className="text-sm text-muted-foreground">There may be a new version of the app, or the connection dropped. Reloading usually fixes it.</p>
        <Button onClick={() => window.location.reload()} className="gap-2">
          <RefreshCw aria-hidden /> Reload
        </Button>
      </div>
    );
  }
}
